import { type TransformedAssortmentSkuLocationsResponse } from '../schemas/get-assortment-sku-locations.schema';

export const assortmentReducerPath = 'assortmentLegacyApi' as const;

export type RowIdentifiersLoc = {
  locationId: string;
};

export type RowIdentifiersSkuLoc = {
  locationId: string;
  skuId: string;
};

export type SkuLocationsResponseTypes =
  TransformedAssortmentSkuLocationsResponse;
